<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        مشاهده لیست حضور و غیاب
      </h4>
    </b-card-header>
    <b-card-body>
      <b-alert show
               variant="info">
        <div class="alert-body">
          <feather-icon
              class="mr-25"
              icon="InfoIcon"
          />
          <span class="ml-25"
          >اطلاعات ورود و خروج هر  <strong> ده دقیقه </strong> یکبار به روز می شود.</span>

        </div>
      </b-alert>
      <!--            <b-button-->
      <!--                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"-->
      <!--                    variant="success"-->
      <!--                    class="mb-1 float-right"-->
      <!--                    target="_blank"-->
      <!--                    :href="exportExcel"-->
      <!--            >-->
      <!--                <feather-icon-->
      <!--                        icon="FileTextIcon"-->
      <!--                        class="mr-50"-->
      <!--                />-->
      <!--                <span class="align-middle">خروجی اکسل</span>-->
      <!--            </b-button>-->
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-toggle.filter-box
          variant="outline-primary"
          class="mb-1"
      >
        <feather-icon
            icon="FilterIcon"
            class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
          id="filter-box"
          class="mb-2"
      >
        <b-card class="border mb-0">
          <b-form @submit.prevent>
            <b-row>
              <b-col v-if="$store.state.user.data.roles.includes('Administrator')" md="4">
                <b-form-group>
                  <label for="permissions">
                    کاربران درخواست دهنده
                  </label>
                  <v-select
                      :key="search.users"
                      v-model="search.users"
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                      :reduce="receiver => receiver.id"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                    label="از تاریخ"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.fromDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      format="jYYYYjMMjDD"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                    label="تا تاریخ"
                    label-for="due-date"
                >
                  <date-picker
                      v-model="search.toDate"
                      type="date"
                      display-format="jDD jMMMM jYYYY"
                      :min="search.fromDate"
                      format="jYYYYjMMjDD"
                      clearable
                  />

                </b-form-group>
              </b-col>
            </b-row>

            <hr>
            <div class="demo-inline-spacing">
              <b-button
                  type="submit"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  @click="advanceSearch"
              >
                اعمال جستجو
              </b-button>
              <b-button
                  type="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-secondary"
                  @click="clearSearch"
              >
                حذف فیلترها
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-collapse>
      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
              :fields="fields"
              :items="items"
              hover
              striped
              responsive
              show-empty
              empty-text="رکوردی یافت نشد"
          >


            <template #cell(cards)="data">

              <template v-if="data.value.length">
                <b-badge variant="light-info" class="ml-1" v-for="(card, index) in data.value" :key="index">
                  {{ card }}
                </b-badge>
              </template>

              <b-badge variant="light-danger" class="ml-1" v-else>
                بدون زمان
              </b-badge>
            </template>
            <template #cell(action)="data">

              <!--                            <b-button-->
              <!--                                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"-->
              <!--                                    variant="flat-primary"-->
              <!--                                    :to="{name: 'Requests_Detail', params:{id: data.item.id}}"-->
              <!--                            >-->
              <!--                                <feather-icon-->
              <!--                                        icon="FileTextIcon"-->
              <!--                                        class="mr-50"-->
              <!--                                />-->
              <!--                                <span class="align-middle">مشاهده</span>-->
              <!--                            </b-button>-->
            </template>

          </b-table>
        </div>
      </b-overlay>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BOverlay,
  BPagination,
  BBadge,
  BButton, VBTooltip, BCollapse, BFormInput, BRow, BCol, BFormGroup, VBToggle, BTab, BTabs, BForm, BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import VSelect from 'vue-select'
import {doubleRaf, queryString} from '@/libs/utils'
import {debounce} from '@/libs/debounce'

export default {
  name: 'ArchiveRequest',
  components: {
    BAlert,
    BTabs,
    BTab,
    BFormGroup,
    BCol,
    BRow,
    BFormInput,
    BCollapse,
    VSelect,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BOverlay,
    BPagination,
    BBadge,
    BButton,
    BForm,

  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'شماره پرسنلی',
        },
        {
          key: 'date',
          label: 'تاریخ حضور',
        },
        {
          key: 'cards',
          label: 'زمان های حضور',
        },
        {
          key: 'extraTime',
          label: 'اضافه کاری',
        },
        {
          key: 'abs',
          label: 'کسر کار',
        },
        {
          key: 'delay',
          label: 'تأخیر',
        },
        {
          key: 'vacation',
          label: 'مرخصی',
        },
        {
          key: 'description',
          label: 'توضیحات',
        },

        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      onProgress: false,
      companyList: [],
      processes: [],
      processProgress: false,
      processFields: [],
      rolesList: [],
      permissionList: [],
      receiversList: [],
      getReceivers: false,
      mainProcess: null,
      childProcess: [],
      finisher: null,
      search: {},
      statuses: [],
    }
  },
  computed: {
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}hr?export-excel=1&${query}`
    },
  },
  watch: {
    mainProcess(newValue, oldValue) {
      if (newValue !== null) {
        const process = this.processes.find(process => process.id === newValue)
        if (process) {
          this.childProcess = process.children

          if (process.children.length > 0) {
            if (process.children.length > 1) {
              this.childProcess = process.children
            }
            doubleRaf(() => {
              this.processId = process.children[0].id
            })
          }
        } else {
          this.childProcess = []
        }
      } else {
        this.childProcess = []
      }

      this.processId = null
    },

  },
  mounted() {
    this.getAttendanceList()
  },
  methods: {
    async getAttendanceList() {
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))
      this.onProgress = true
      this.$http.get('attendances', {
        params: {
          ...currentQuery,
          ...this.search,
        },
      })
          .then(({data}) => {
            if (data.status) {
              this.items = data.data
            } else {
              this.$bvToast.toast(data.status ?? 'لیست حضور غیاب دریافت نشد', {
                title: 'خطای دریافت اطلاعات',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
          .then(() => {
            this.getAttendanceList()
          })
          .catch(() => {
          })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({behavior: 'smooth'})
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
          .then(() => {
            this.getAttendanceList()
          })
          .catch(() => {
          })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({behavior: 'smooth'})
      })
    },
    getRelatedUsers(q) {
      this.$http.get(`user/list?name=${q}`)
          .then(({data}) => {
            this.receiversList = data
            this.getReceivers = true
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.searchUser(loading, search, this)
      }
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search)
      loading(false)
    }, 400),
  },

}
</script>

<style>

</style>
